<template>
	<div class="leftres">
		<div>
			<div :class=" showorhide ? 'inputtop' : 'inputtops' ">
				<div v-for="(item , index) of formdata" :key="index" style="display: inline-block;">
					<Commondropdownlist ref="ProductRef" :widthLeft="item.widthLeft" :widthRight="item.widthRight"
						:widths="item.widths" :options="item.options" :lablewith="item.lablewith"
						:inputdata="item.inputdata" :title="item.title" :fontSize="item.fontSize" :color="item.color"
						:placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype"
						:width="item.width"></Commondropdownlist>
				</div>
				<div :class=" showorhide ? 'Btngroups' : 'Btngroup' ">
					<CommonBtngroup ref="MyApprovalbtngroup" :show="showorhide" @showclick="showclick" @hide="hide"
						@select="select" @reset="reset"></CommonBtngroup>
				</div>
				<div style="height:10px;"></div>
			</div>
			<div class="TableBox"
				style="box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1); margin-top: 10px; background-color: #FFFFFF;">
				<Producttable :tableData="tableData" :total="total" @CRExport="CRExport"
					@handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange"></Producttable>
			</div>
			<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibles" @cancel="cancel" @dialogOK="dialogOK"
				:src="'../assets/icon/icon-errors.png'">
				<span
					style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要重置选中账号的密码吗？</span>
			</Dialog>
		</div>
	</div>
</template>
<script>
	import Commondropdownlist from "../../../components/common-dropdownlist.vue";
	import CommonBtngroup from "../../../components/commongroup.vue";
	import Dialog from "../../../components/dialog.vue";
	import Producttable from "./components/Producttable.vue";
	import formdata from "./fromData/formdata";
	import utils from "../../../common/utils";
	import {
		ProductList,
		CusRelationProviderExport,
		InventoryClassList,
		HelperInvType,
		ManufacturerList
	} from "@/api/home";

	export default {
		components: {
			Commondropdownlist,
			Producttable,
			Dialog,
			CommonBtngroup
		},
		data() {
			return {
				tableData: [],
				total: 1,
				pageindex: 1,
				pageSize: 20,
				dialogVisibles: false,
				showorhide: true,
				chackbox: true,
				formdata: [],
				from: {
					InvClass: "",
					MFCode: "",
					InvName: "",
					RegistrationNo: "",
					ShowName: "",
					InvType: "",
					MarkupRate: ""
				}
			};
		},
		created() {

		},
		mounted() {
			this.formdata = JSON.parse(JSON.stringify(formdata));
			this.ProductList();
			this.inventoryClassList();
			this.HelperInvType()
			this.ManufacturerList()
			// this.$refs.ProductRef[6].modelvalue = ''
			console.log(this.$refs.ProductRef);
		},
		methods: {
			// 列表
			async ProductList() {
				const loading = this.$loading({
					lock: true,
					text: "正在加载列表中...",
					spinner: "el-icon-loading",
					background: "rgba(255,255,255,0.3)"
				});
				let {
					data,
					code,
					message
				} = await ProductList({
					InvClass: this.from.InvClass,
					MFCode: this.from.MFCode,
					InvName: this.from.InvName,
					RegistrationNo: this.from.RegistrationNo,
					ShowName: this.from.ShowName,
					InvType: this.from.InvType,
					MarkupRate: this.from.MarkupRate,
					pageSize: this.pageSize,
					pageIndex: this.pageindex
				});
				if (code == 0) {
					this.total = data.Count;
					this.tableData = data.data;
				} else {
					this.$message(message);
				}
				loading.close();
			},
			// 导出
			async cusRelationProviderExport() {
				let resexprot = await CusRelationProviderExport({
					InvClass: this.from.InvClass,
					MFCode: this.from.MFCode,
					InvName: this.from.InvName,
					RegistrationNo: this.from.RegistrationNo,
					ShowName: this.from.ShowName,
					InvType: this.from.InvType,
					MarkupRate: this.from.MarkupRate,
					pageSize: this.pageSize,
					pageIndex: this.pageindex
				});
				if (resexprot) {
					//console.log(resexprot);
					if (resexprot.code == 999) {
						this.$message({
							type: "warning",
							message: resexprot.message
						});
					}
					let date = new Date();
					let str = `${date.getFullYear()}-${date.getMonth() +
          1}-${date.getDate()}-${date.getTime()}`;
					utils.downloadFile(
						resexprot.data,
						`经销商/服务商/医院备案${str}`,
						"xlsx"
					);
				} else {
					// 返回json
					this.$message.warning("导出失败");
				}
			},
			CRExport() {
				// this.cusRelationProviderExport();
			},
			// 产品线下拉
			async inventoryClassList() {
				let {
					code,
					data
				} = await InventoryClassList({});
				if (code == 0) {
					this.formdata[0].options = [];
					this.$children[1].EditrFrom[0].options = [];
					this.$children[1].AddForm[0].options = [];
					data.data.map((item, index) => {
						let obj = {
							key: item.InvClass,
							value: item.InvClassName
						};
						this.formdata[0].options.push(obj);
						this.$children[1].EditrFrom[0].options.push(obj);
						this.$children[1].AddForm[0].options.push(obj);
					});
				}
			},
			// 生产厂商下拉
			async ManufacturerList() {
				let {
					code,
					data
				} = await ManufacturerList({});
				if (code == 0) {
					this.formdata[1].options = [];
					this.$children[1].EditrFrom[1].options = [];
					this.$children[1].AddForm[1].options = [];
					data.data.map((item, index) => {
						let obj = {
							key: item.MFCode,
							value: item.MFName
						};
						this.formdata[1].options.push(obj);
						this.$children[1].EditrFrom[1].options.push(obj);
						this.$children[1].AddForm[1].options.push(obj);
					});
				}
			},

			// 产品类别 下拉
			async HelperInvType() {
				let {
					code,
					data
				} = await HelperInvType({});
				if (code == 0) {
					this.formdata[5].options = [];
					this.$children[1].EditrFrom[5].options = [];
					data.map((item, index) => {
						let obj = {
							key: item.Value,
							value: item.Text
						};
						this.formdata[5].options.push(obj);
						this.$children[1].EditrFrom[5].options.push(obj);
					});
				}
			},


			reset() {
				this.$refs.ProductRef.map((item, index) => {
					if (index == 6) {
						item.CommModelvalue = undefined;
					}
					item.modelvalue = "";
				});
				this.$refs.MyApprovalbtngroup.checkeds = false;
			},
			cancel() {
				// //console.log('name')
				this.dialogVisibles = false;
			},
			dialogOK() {
				// //console.log('name2')
				this.dialogVisibles = false;
			},
			hide() {
				this.showorhide = false;
				this.chackbox = false;
				// //console.log("askdas", this.showorhide)
			},
			showclick() {
				this.showorhide = true;
				this.chackbox = true;
			},
			select() {
				// 处理异常（折叠搜索框）
				this.pageindex = 1;
				try {
					this.from.InvClass = this.$refs.ProductRef[0].modelvalue;
					this.from.MFCode = this.$refs.ProductRef[1].modelvalue;
					this.from.InvName = this.$refs.ProductRef[2].modelvalue;
					this.from.RegistrationNo = this.$refs.ProductRef[3].modelvalue
					this.from.ShowName = this.$refs.ProductRef[4].modelvalue
					this.from.InvType = this.$refs.ProductRef[5].modelvalue;
					this.from.MarkupRate = this.$refs.ProductRef[6].CommModelvalue;
					this.ProductList();
				} catch (error) {
					this.ProductList();
				}
			},
			handleCurrentChange(pageindex) {
				this.pageindex = pageindex;
				this.ProductList();
			},
			handleSizeChange(paegSize) {
				this.pageSize = paegSize;
				this.ProductList();
			}
		},
		watch: {
			$route: {
				handler(to, from) {},
				deep: true,
				immediate: true
			}
		}
	};
</script>

<style lang="less" scoped>
	.inputtop {
		width: 980px;
		height: 95px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		background-color: #ffffff;
		padding-top: 15px;
		padding-bottom: 70px;
		transition: all 0.3s;
		overflow: hidden;
	}

	.inputtops {
		width: 980px;
		height: 0px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		background-color: #ffffff;
		padding-top: 9px;
		padding-bottom: 64px;
		overflow: hidden;
		position: relative;
		transition: all 0.3s;
	}

	.Btngroup {
		display: inline-block;
		float: right;
		margin-right: 20px;
		width: 320px;
		height: 50px;
		background-color: #ffffff;
		position: relative;
		bottom: 95px;
	}

	.Btngroups {
		display: inline-block;
		float: right;
		margin-top: 5px;
		margin-right: 10px;
	}
</style>